import { euclideanDistance } from '@/modules/Editor/algebra'
import type { IPoint } from '@/modules/Editor/point'

/**
 * Checks if significant movement has occurred between two points
 *
 * This is useful for determining whether to interrupt other interactions
 * (like panning) when an annotation is detected under the cursor.
 *
 * @param initialPosition - Starting position
 * @param currentPosition - Current position
 * @param threshold - Pixel threshold for "significant" movement (default: 5)
 * @returns true if movement exceeds threshold, false otherwise
 */
export const hasMovedSignificantly = (
  initialPosition: IPoint | undefined,
  currentPosition: IPoint | undefined,
  threshold: number = 5,
): boolean => {
  if (!initialPosition || !currentPosition) {
    return false
  }

  const distance = euclideanDistance(initialPosition, currentPosition)
  return distance > threshold
}
